import classNames from 'classnames';
import useCategories from '../../hooks/useCategories';
import CheckIcon from "../../assets/icons/CheckIcon";

export default function BusinessCategories({ businessId, role, disabled, setEditedRole, onChange, setCategoryBusiness }) {

  const { data: categories } = useCategories({ businessId, staleTime: 10000 });

  if (!categories) {
    return;
  }

  if (categories.length === 0) {
    return (
      <div className='empty-business'>This business has no categories</div>
    )
  }

  const onToggleCategory = (id, checked) => {
    setEditedRole(draft => {
      if (checked) {
        draft.category_ids.push(id);
        setCategoryBusiness(draft => {
          !draft.includes(businessId) && draft.push(businessId);
        });
      }
      else {
        const index = draft.category_ids.findIndex(categoryId => categoryId === id);
        draft.category_ids.splice(index, 1);

        const checked = categories.some(category => draft.category_ids.includes(category.id));
        if (!checked) {
          setCategoryBusiness(draft => {
            const index = draft.findIndex(id => id === businessId);

            if (index !== -1) {
              draft.splice(index, 1);
            }
          });
        }
      }
    });

    onChange();
  }

  return (
    <div className='categories-overflow'>
      { categories.map(category => (
        <button disabled={disabled} key={category.id} className={classNames('category-toggle', { selected: role.category_ids.includes(category.id) })} onClick={() => onToggleCategory(category.id, !role.category_ids.includes(category.id) )}>
          <div className={classNames('check-container', { checked: role.category_ids.includes(category.id) })}><CheckIcon /></div>
          <div className='category-label'>{ category.name }</div>
        </button>
      ))}
    </div>
  );
}
